<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

// ── Data: Daftar permission yang tersedia di sistem ───────────────────────────
const permissionGroups = [
  {
    group: 'Dashboard',
    icon: 'ri-dashboard-line',
    color: 'primary',
    permissions: [
      { name: 'dashboard.view', label: 'Lihat Dashboard', desc: 'Bisa melihat ringkasan penjualan dan statistik hari ini' },
    ],
  },
  {
    group: 'Produk & Katalog',
    icon: 'ri-cup-line',
    color: 'info',
    permissions: [
      { name: 'products.view', label: 'Lihat Produk', desc: 'Bisa melihat daftar produk dan harga' },
      { name: 'products.create', label: 'Tambah Produk', desc: 'Bisa menambah produk baru ke katalog' },
      { name: 'products.update', label: 'Edit Produk', desc: 'Bisa mengubah nama, harga, dan detail produk' },
      { name: 'products.delete', label: 'Hapus Produk', desc: 'Bisa menghapus produk dari katalog' },
    ],
  },
  {
    group: 'Bahan Baku',
    icon: 'ri-flask-line',
    color: 'success',
    permissions: [
      { name: 'ingredients.view', label: 'Lihat Bahan', desc: 'Bisa melihat stok bahan baku' },
      { name: 'ingredients.create', label: 'Tambah Bahan', desc: 'Bisa menambah bahan baku baru' },
      { name: 'ingredients.update', label: 'Edit Bahan', desc: 'Bisa mengubah detail bahan baku' },
      { name: 'ingredients.delete', label: 'Hapus Bahan', desc: 'Bisa menghapus bahan baku' },
    ],
  },
  {
    group: 'Pembelian',
    icon: 'ri-shopping-cart-line',
    color: 'warning',
    permissions: [
      { name: 'purchases.view', label: 'Lihat PO', desc: 'Bisa melihat daftar purchase order' },
      { name: 'purchases.create', label: 'Buat PO', desc: 'Bisa membuat purchase order baru ke supplier' },
      { name: 'purchases.update', label: 'Edit PO', desc: 'Bisa mengubah isi purchase order' },
      { name: 'purchases.receive', label: 'Terima Barang', desc: 'Bisa konfirmasi penerimaan barang dari supplier' },
    ],
  },
  {
    group: 'Inventori',
    icon: 'ri-archive-line',
    color: 'secondary',
    permissions: [
      { name: 'inventory.view', label: 'Lihat Inventori', desc: 'Bisa melihat pergerakan stok dan history' },
      { name: 'inventory.adjust', label: 'Adjust Stok', desc: 'Bisa melakukan penyesuaian stok dan stock opname' },
    ],
  },
  {
    group: 'Kasir (POS)',
    icon: 'ri-store-2-line',
    color: 'success',
    permissions: [
      { name: 'pos.access', label: 'Akses Kasir', desc: 'Bisa membuka aplikasi kasir dan melayani pelanggan' },
      { name: 'orders.view', label: 'Lihat Pesanan', desc: 'Bisa melihat riwayat pesanan' },
      { name: 'orders.void', label: 'Void Pesanan', desc: 'Bisa membatalkan transaksi yang sudah terjadi' },
    ],
  },
  {
    group: 'Shift',
    icon: 'ri-time-line',
    color: 'info',
    permissions: [
      { name: 'shifts.open', label: 'Buka Shift', desc: 'Bisa membuka shift kasir di awal hari' },
      { name: 'shifts.close', label: 'Tutup Shift', desc: 'Bisa menutup shift dan hitung hasil penjualan' },
      { name: 'shifts.view', label: 'Lihat Shift', desc: 'Bisa melihat riwayat shift sebelumnya' },
    ],
  },
  {
    group: 'Pengeluaran',
    icon: 'ri-wallet-3-line',
    color: 'error',
    permissions: [
      { name: 'expenses.view', label: 'Lihat Pengeluaran', desc: 'Bisa melihat catatan pengeluaran operasional' },
      { name: 'expenses.create', label: 'Catat Pengeluaran', desc: 'Bisa menambah catatan pengeluaran baru' },
      { name: 'expenses.update', label: 'Edit Pengeluaran', desc: 'Bisa mengubah catatan pengeluaran' },
      { name: 'expenses.delete', label: 'Hapus Pengeluaran', desc: 'Bisa menghapus catatan pengeluaran' },
    ],
  },
  {
    group: 'Laporan',
    icon: 'ri-bar-chart-line',
    color: 'primary',
    permissions: [
      { name: 'reports.view', label: 'Lihat Laporan', desc: 'Bisa mengakses semua laporan: penjualan, inventori, laba rugi' },
    ],
  },
  {
    group: 'User & Akses',
    icon: 'ri-team-line',
    color: 'warning',
    permissions: [
      { name: 'users.view', label: 'Lihat User', desc: 'Bisa melihat daftar karyawan yang terdaftar' },
      { name: 'users.create', label: 'Tambah User', desc: 'Bisa membuat akun karyawan baru' },
      { name: 'users.update', label: 'Edit User', desc: 'Bisa mengubah data karyawan dan mengaktifkan/nonaktifkan akun' },
      { name: 'users.delete', label: 'Hapus User', desc: 'Bisa menghapus akun karyawan permanen' },
      { name: 'roles.view', label: 'Lihat Role', desc: 'Bisa melihat daftar role dan permission yang ada' },
      { name: 'roles.create', label: 'Buat Role', desc: 'Bisa membuat role baru dengan permission custom' },
      { name: 'roles.update', label: 'Edit Role', desc: 'Bisa mengubah permission yang dimiliki sebuah role' },
    ],
  },
  {
    group: 'Pengaturan & Audit',
    icon: 'ri-settings-3-line',
    color: 'secondary',
    permissions: [
      { name: 'settings.view', label: 'Lihat Pengaturan', desc: 'Bisa melihat konfigurasi toko' },
      { name: 'settings.update', label: 'Ubah Pengaturan', desc: 'Bisa mengubah nama toko, pajak, struk, dll' },
      { name: 'audit.view', label: 'Lihat Audit Log', desc: 'Bisa melihat siapa melakukan apa dan kapan' },
    ],
  },
]

// ── Data: Contoh role yang umum di UMKM ──────────────────────────────────────
const contohRole = [
  {
    nama: 'Pemilik / Owner',
    icon: 'ri-vip-crown-line',
    color: 'warning',
    cocok: 'Anda sendiri, atau manajer kepercayaan penuh',
    permissions: 'Semua permission diaktifkan',
    catatan: 'Hati-hati memberi role ini ke karyawan. Mereka bisa lihat semua laporan keuangan dan hapus data.',
  },
  {
    nama: 'Kasir',
    icon: 'ri-store-2-line',
    color: 'success',
    cocok: 'Karyawan yang hanya bertugas melayani pelanggan di kasir',
    permissions: 'pos.access, orders.view, shifts.open, shifts.close, dashboard.view',
    catatan: 'Tidak perlu akses ke laporan keuangan, stok, atau pengaturan toko.',
  },
  {
    nama: 'Supervisor / Kepala Shift',
    icon: 'ri-user-star-line',
    color: 'primary',
    cocok: 'Karyawan senior yang mengawasi kasir dan bisa void transaksi',
    permissions: 'Semua akses kasir + orders.void + shifts.view + expenses.view',
    catatan: 'Bisa membatalkan transaksi yang salah. Perlu pengawasan dan kepercayaan ekstra.',
  },
  {
    nama: 'Gudang / Stok',
    icon: 'ri-archive-line',
    color: 'info',
    cocok: 'Karyawan yang mengurus bahan baku dan pembelian',
    permissions: 'ingredients.*, inventory.*, purchases.*, products.view',
    catatan: 'Tidak perlu akses kasir atau laporan keuangan.',
  },
  {
    nama: 'Akuntan / Keuangan',
    icon: 'ri-calculator-line',
    color: 'error',
    cocok: 'Staf yang mengurus pembukuan dan laporan',
    permissions: 'reports.view, expenses.*, dashboard.view',
    catatan: 'Tidak perlu akses kasir atau manajemen stok.',
  },
]

// ── FAQ ────────────────────────────────────────────────────────────────────────
const faqUser = [
  {
    q: 'Berapa banyak user yang bisa saya tambahkan?',
    a: 'Jumlah user tergantung paket langganan PintuKasir Anda. Cek halaman Pengaturan → Info Paket untuk melihat batas user aktif di toko Anda.',
  },
  {
    q: 'Apakah karyawan bisa login dengan email yang sama di dua perangkat?',
    a: 'Bisa. Satu akun bisa dipakai di beberapa perangkat secara bersamaan. Namun untuk keamanan, sebaiknya setiap karyawan punya akun sendiri agar aktivitas tercatat per individu di audit log.',
  },
  {
    q: 'Bagaimana jika karyawan lupa password?',
    a: 'Sebagai pemilik toko (admin), Anda bisa edit akun karyawan tersebut dan ganti passwordnya. Karyawan tidak bisa reset password sendiri — harus minta pemilik toko. Ini untuk keamanan.',
  },
  {
    q: 'Apakah bisa menonaktifkan akun karyawan sementara (misalnya saat cuti panjang)?',
    a: 'Bisa! Di halaman Daftar User, klik tombol toggle di kolom "Status". Karyawan yang nonaktif tidak bisa login sama sekali, tapi data dan riwayat transaksinya tetap tersimpan. Aktifkan kembali kapan saja jika karyawan sudah kembali bekerja.',
  },
  {
    q: 'Apa yang terjadi dengan data karyawan jika akun dihapus?',
    a: 'Data transaksi, pesanan, dan laporan yang sudah dibuat oleh karyawan tersebut tetap tersimpan di sistem. Hanya akun loginnya yang dihapus. Jadi laporan historis Anda tidak akan terpengaruh.',
  },
  {
    q: 'Bisakah satu karyawan punya dua role sekaligus?',
    a: 'Di PintuKasir, setiap user hanya bisa memiliki satu role. Jika karyawan Anda punya tugas ganda (misalnya kasir sekaligus ngurusin stok), buat role baru khusus yang menggabungkan permission keduanya.',
  },
]

const faqRole = [
  {
    q: 'Apakah role bawaan (owner, kasir) bisa dihapus?',
    a: 'Role tidak bisa dihapus di PintuKasir. Ini untuk mencegah akun karyawan yang masih aktif kehilangan role-nya secara tidak sengaja. Jika role sudah tidak dipakai, biarkan saja — tidak akan mengganggu sistem.',
  },
  {
    q: 'Bagaimana jika saya salah berikan permission ke sebuah role?',
    a: 'Anda bisa edit role kapan saja dan ubah permission-nya. Perubahan berlaku langsung — karyawan dengan role tersebut akan kehilangan atau mendapatkan akses baru begitu mereka refresh halaman.',
  },
  {
    q: 'Bolehkah role kasir diberi akses void pesanan?',
    a: 'Boleh, tapi pertimbangkan risikonya. Kasir yang bisa void transaksi bisa menghapus bukti penjualan. Untuk keamanan, biasanya akses void diberikan ke supervisor atau manager saja.',
  },
  {
    q: 'Apakah ada limit jumlah role yang bisa dibuat?',
    a: 'Tidak ada limit. Anda bisa buat role sebanyak yang dibutuhkan. Tapi untuk kemudahan pengelolaan, usahakan tidak terlalu banyak — 3 sampai 5 role sudah cukup untuk kebanyakan UMKM.',
  },
  {
    q: 'Apakah pemilik toko (owner) bisa kehilangan akses ke sistemnya sendiri?',
    a: 'Tidak bisa. Sistem melindungi akun pemilik utama agar tidak bisa dinonaktifkan atau dihapus oleh orang lain. Anda aman.',
  },
]

const activeTab = ref('user')
</script>

<template>
  <div>
    <!-- Breadcrumb -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center gap-2 mb-2">
          <RouterLink
            to="/userguide"
            class="text-decoration-none text-medium-emphasis text-body-2"
          >
            User Guide
          </RouterLink>
          <VIcon icon="ri-arrow-right-s-line" size="16" class="text-medium-emphasis" />
          <span class="text-body-2">User & Role</span>
        </div>
      </VCol>
    </VRow>

    <!-- Header -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center gap-4 mb-4">
          <VAvatar color="warning" variant="tonal" size="64" rounded="lg">
            <VIcon icon="ri-shield-keyhole-line" size="36" />
          </VAvatar>
          <div>
            <h4 class="text-h4 font-weight-bold mb-1">
              User & Manajemen Akses
            </h4>
            <p class="text-body-1 text-medium-emphasis mb-0">
              Kelola akun karyawan dan atur siapa boleh melakukan apa di PintuKasir
            </p>
          </div>
        </div>

        <VAlert type="info" variant="tonal" icon="ri-flag-line" class="mb-0">
          <strong>Tujuan halaman ini:</strong>
          Panduan lengkap untuk menambah akun karyawan, membuat role (jabatan), dan
          mengatur hak akses setiap karyawan agar data bisnis Anda tetap aman dan terkontrol.
        </VAlert>
      </VCol>
    </VRow>

    <!-- ═══════════════════════════════════════════════════════════════════════
         SECTION 1: Konsep Dasar
    ════════════════════════════════════════════════════════════════════════════ -->
    <VRow class="mt-6">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-5 pb-2">
            <VIcon icon="ri-book-open-line" class="me-2" color="warning" />
            Apa itu User dan Role?
          </VCardTitle>
          <VCardText class="pa-5 pt-3">
            <VRow>
              <VCol cols="12" md="6">
                <div class="d-flex gap-3 mb-4">
                  <VAvatar color="primary" variant="tonal" size="44" rounded>
                    <VIcon icon="ri-user-line" size="22" />
                  </VAvatar>
                  <div>
                    <p class="font-weight-bold text-body-1 mb-1">👤 User (Pengguna)</p>
                    <p class="text-body-2 text-medium-emphasis mb-0">
                      User adalah akun login untuk setiap karyawan Anda.
                      Sama seperti kartu akses di kantor — setiap karyawan punya
                      kartu sendiri yang bisa dibuka/ditutup aksesnya kapan saja.
                    </p>
                  </div>
                </div>
                <p class="text-body-2 mb-0">
                  Contoh: Budi adalah barista Anda. Anda buatkan akun dengan email
                  <strong>budi@kopikita.com</strong> dan password. Budi pakai akun ini
                  untuk login ke PintuKasir setiap hari kerja.
                </p>
              </VCol>

              <VCol cols="12" md="6">
                <div class="d-flex gap-3 mb-4">
                  <VAvatar color="warning" variant="tonal" size="44" rounded>
                    <VIcon icon="ri-shield-user-line" size="22" />
                  </VAvatar>
                  <div>
                    <p class="font-weight-bold text-body-1 mb-1">🛡️ Role (Jabatan / Hak Akses)</p>
                    <p class="text-body-2 text-medium-emphasis mb-0">
                      Role adalah "jabatan" yang menentukan apa yang boleh dilakukan
                      oleh user. Satu role bisa dimiliki banyak karyawan.
                    </p>
                  </div>
                </div>
                <p class="text-body-2 mb-0">
                  Contoh: Role <strong>"Kasir"</strong> hanya punya akses ke mesin kasir dan
                  pesanan. Role <strong>"Supervisor"</strong> bisa kasir + bisa void transaksi
                  + lihat laporan. Budi diberi role "Kasir" karena tugasnya hanya melayani pembeli.
                </p>
              </VCol>
            </VRow>

            <VDivider class="my-4" />

            <!-- Analogi -->
            <VAlert type="success" variant="tonal" icon="ri-lightbulb-line">
              <p class="font-weight-bold mb-2">🏪 Analogi Warung Kopi</p>
              <p class="text-body-2 mb-2">
                Bayangkan toko Anda seperti warung kopi fisik. Ada beberapa area:
                <strong>area kasir, dapur/bar, gudang, dan ruang manager</strong>.
              </p>
              <ul class="text-body-2 mb-0 ps-4">
                <li class="mb-1">
                  <strong>Kasir</strong> boleh masuk ke area kasir saja
                </li>
                <li class="mb-1">
                  <strong>Barista</strong> boleh masuk area bar + kasir
                </li>
                <li class="mb-1">
                  <strong>Gudang</strong> boleh masuk area gudang + bar
                </li>
                <li>
                  <strong>Manager / Owner</strong> boleh masuk semua area termasuk ruang manager
                </li>
              </ul>
              <p class="text-body-2 mb-0 mt-2">
                Di PintuKasir, <strong>Role</strong> = area mana yang boleh dimasuki.
                <strong>Permission</strong> = pintu-pintu dalam area tersebut.
              </p>
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ═══════════════════════════════════════════════════════════════════════
         SECTION 2: Tab navigasi User / Role
    ════════════════════════════════════════════════════════════════════════════ -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VTabs v-model="activeTab" color="primary" class="mb-4">
          <VTab value="user">
            <VIcon icon="ri-team-line" class="me-2" size="18" />
            Manajemen User (Karyawan)
          </VTab>
          <VTab value="role">
            <VIcon icon="ri-shield-keyhole-line" class="me-2" size="18" />
            Manajemen Role & Permission
          </VTab>
          <VTab value="referensi">
            <VIcon icon="ri-list-check-3" class="me-2" size="18" />
            Referensi Lengkap Permission
          </VTab>
        </VTabs>

        <VTabsWindow v-model="activeTab">

          <!-- ─── TAB 1: USER ──────────────────────────────────────────────── -->
          <VTabsWindowItem value="user">

            <!-- Cara akses halaman User -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-map-pin-line" class="me-2" color="primary" />
                Cara Membuka Halaman Manajemen User
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-3">
                  Di menu sidebar kiri, klik bagian <strong>Administrasi</strong>, lalu pilih
                  <strong>Daftar User</strong>. Anda akan melihat tabel berisi semua karyawan
                  yang sudah terdaftar di toko Anda.
                </p>
                <VAlert type="warning" variant="tonal" density="compact">
                  Hanya user dengan permission <strong>users.view</strong> yang bisa mengakses
                  halaman ini. Jika halaman tidak muncul, berarti akun Anda belum punya akses.
                  Hubungi pemilik toko.
                </VAlert>
              </VCardText>
            </VCard>

            <!-- Tambah user -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-user-add-line" class="me-2" color="success" />
                Cara Menambah Karyawan Baru
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <ol class="text-body-2 ps-4">
                  <li class="mb-3">
                    Buka menu <strong>Administrasi → Daftar User</strong>
                  </li>
                  <li class="mb-3">
                    Klik tombol <strong>"+ Tambah User"</strong> di pojok kanan atas
                  </li>
                  <li class="mb-3">
                    Isi form yang muncul:
                    <VTable class="mt-3 mb-3">
                      <thead>
                        <tr>
                          <th style="min-width:140px">Field</th>
                          <th style="min-width:80px">Wajib?</th>
                          <th>Penjelasan & Contoh</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td><strong>Nama Lengkap</strong></td>
                          <td>
                            <VChip color="error" size="x-small" variant="tonal">✅ Wajib</VChip>
                          </td>
                          <td class="text-body-2 py-2">
                            Nama asli karyawan. Akan muncul di laporan dan audit log.<br>
                            Contoh: <strong>Budi Santoso</strong>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Email</strong></td>
                          <td>
                            <VChip color="error" size="x-small" variant="tonal">✅ Wajib</VChip>
                          </td>
                          <td class="text-body-2 py-2">
                            Digunakan untuk login. Harus unik — tidak boleh sama dengan
                            karyawan lain di toko yang sama.<br>
                            Contoh: <strong>budi@kopikita.com</strong>
                            <br>
                            <span class="text-caption text-medium-emphasis">
                              Tidak harus email yang benar-benar aktif.
                              Bisa pakai format apa saja asalkan berbentuk email.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Password</strong></td>
                          <td>
                            <VChip color="error" size="x-small" variant="tonal">✅ Wajib</VChip>
                          </td>
                          <td class="text-body-2 py-2">
                            Password login karyawan. Minimal 8 karakter.<br>
                            Contoh: <strong>kopikita2024</strong><br>
                            <span class="text-caption text-medium-emphasis">
                              Beritahu password ini ke karyawan secara langsung atau via pesan.
                              Sistem tidak mengirim email otomatis.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Role</strong></td>
                          <td>
                            <VChip color="error" size="x-small" variant="tonal">✅ Wajib</VChip>
                          </td>
                          <td class="text-body-2 py-2">
                            Jabatan/hak akses karyawan ini. Pilih dari daftar role yang sudah ada.<br>
                            Contoh: pilih <strong>kasir</strong> untuk karyawan kasir<br>
                            <span class="text-caption text-medium-emphasis">
                              Role harus dibuat terlebih dahulu di menu Role &amp; Permission.
                              Lihat tab "Manajemen Role" di atas.
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>Akun Aktif</strong></td>
                          <td>
                            <VChip color="secondary" size="x-small" variant="tonal">❌ Opsional</VChip>
                          </td>
                          <td class="text-body-2 py-2">
                            Toggle on/off. Default: aktif (bisa login langsung).
                            Nonaktifkan jika karyawan belum boleh login dulu.
                          </td>
                        </tr>
                      </tbody>
                    </VTable>
                  </li>
                  <li class="mb-3">
                    Klik <strong>"Simpan"</strong>
                  </li>
                  <li>
                    Karyawan sudah bisa login menggunakan email dan password yang Anda buat ✅
                  </li>
                </ol>
              </VCardText>
            </VCard>

            <!-- Edit user -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-edit-line" class="me-2" color="warning" />
                Cara Mengubah Data Karyawan
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-3">
                  Anda perlu edit data karyawan jika: nama/email berubah, karyawan naik jabatan
                  (ganti role), atau karyawan lupa password.
                </p>
                <ol class="text-body-2 ps-4">
                  <li class="mb-2">
                    Di halaman Daftar User, temukan baris karyawan yang ingin diubah
                  </li>
                  <li class="mb-2">
                    Klik ikon <strong>pensil (✏️)</strong> di kolom Aksi
                  </li>
                  <li class="mb-2">
                    Ubah data yang perlu diubah:
                    <ul class="mt-2 ps-4">
                      <li class="mb-1">
                        <strong>Ganti nama/email</strong> — langsung ubah di field yang sesuai
                      </li>
                      <li class="mb-1">
                        <strong>Ganti role</strong> — pilih role baru dari dropdown
                      </li>
                      <li class="mb-1">
                        <strong>Reset password</strong> — isi field Password Baru. Kosongkan jika tidak mau ganti password
                      </li>
                    </ul>
                  </li>
                  <li>
                    Klik <strong>"Simpan"</strong>
                  </li>
                </ol>
              </VCardText>
            </VCard>

            <!-- Nonaktifkan user -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-toggle-line" class="me-2" color="info" />
                Cara Mengaktifkan / Menonaktifkan Karyawan
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-4">
                  Fitur ini berguna saat karyawan cuti panjang, sedang dalam masa percobaan,
                  atau sudah tidak bekerja tapi datanya ingin Anda simpan.
                </p>

                <VRow>
                  <VCol cols="12" md="6">
                    <VCard variant="outlined" color="success">
                      <VCardText class="pa-4">
                        <p class="font-weight-bold text-success mb-2">
                          ✅ Cara Nonaktifkan
                        </p>
                        <ol class="text-body-2 ps-4 mb-0">
                          <li class="mb-1">
                            Temukan nama karyawan di tabel
                          </li>
                          <li class="mb-1">
                            Di kolom <strong>Status</strong>, ada tombol toggle
                          </li>
                          <li class="mb-1">
                            Klik toggle — warna akan berubah menjadi abu-abu
                          </li>
                          <li>
                            Karyawan langsung tidak bisa login ✓
                          </li>
                        </ol>
                      </VCardText>
                    </VCard>
                  </VCol>
                  <VCol cols="12" md="6">
                    <VCard variant="outlined" color="primary">
                      <VCardText class="pa-4">
                        <p class="font-weight-bold text-primary mb-2">
                          🔄 Cara Aktifkan Kembali
                        </p>
                        <ol class="text-body-2 ps-4 mb-0">
                          <li class="mb-1">
                            Temukan nama karyawan (yang statusnya nonaktif)
                          </li>
                          <li class="mb-1">
                            Klik toggle yang berwarna abu-abu
                          </li>
                          <li class="mb-1">
                            Toggle berubah jadi hijau
                          </li>
                          <li>
                            Karyawan bisa login kembali ✓
                          </li>
                        </ol>
                      </VCardText>
                    </VCard>
                  </VCol>
                </VRow>

                <VAlert type="info" variant="tonal" class="mt-4" density="compact">
                  <strong>Informasi:</strong> Menonaktifkan akun TIDAK menghapus data transaksi
                  dan laporan yang pernah dibuat oleh karyawan tersebut. Semua riwayat tetap aman.
                </VAlert>
              </VCardText>
            </VCard>

            <!-- Hapus user -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-delete-bin-line" class="me-2" color="error" />
                Cara Menghapus Akun Karyawan
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <VAlert type="error" variant="tonal" class="mb-4">
                  <strong>⚠️ Perhatian:</strong> Hapus akun hanya jika Anda yakin karyawan ini
                  tidak akan pernah kembali bekerja. Untuk karyawan yang cuti atau dipecat sementara,
                  lebih baik <strong>nonaktifkan saja</strong> daripada hapus.
                </VAlert>

                <ol class="text-body-2 ps-4">
                  <li class="mb-2">
                    Klik ikon <strong>tempat sampah (🗑️)</strong> di baris karyawan
                  </li>
                  <li class="mb-2">
                    Baca dialog konfirmasi dengan teliti — pastikan nama yang muncul benar
                  </li>
                  <li>
                    Klik <strong>"Hapus"</strong> untuk konfirmasi
                  </li>
                </ol>

                <VAlert type="warning" variant="tonal" class="mt-4" density="compact">
                  <strong>Catatan:</strong> Anda tidak bisa menghapus akun Anda sendiri.
                  Sistem memblokir ini untuk mencegah toko kehilangan admin utamanya.
                </VAlert>
              </VCardText>
            </VCard>

            <!-- Filter dan pencarian -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-filter-line" class="me-2" color="secondary" />
                Mencari dan Menyaring Daftar Karyawan
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-3">
                  Jika toko Anda punya banyak karyawan, gunakan fitur filter untuk menemukan
                  dengan cepat.
                </p>
                <VRow>
                  <VCol cols="12" md="4">
                    <div class="d-flex gap-2 align-start mb-2">
                      <VIcon icon="ri-search-line" color="primary" size="18" class="mt-1" />
                      <div>
                        <p class="font-weight-medium text-body-2 mb-1">
                          Cari Nama / Email
                        </p>
                        <p class="text-body-2 text-medium-emphasis mb-0">
                          Ketik sebagian nama atau email. Hasil muncul otomatis saat Anda mengetik.
                        </p>
                      </div>
                    </div>
                  </VCol>
                  <VCol cols="12" md="4">
                    <div class="d-flex gap-2 align-start mb-2">
                      <VIcon icon="ri-shield-line" color="warning" size="18" class="mt-1" />
                      <div>
                        <p class="font-weight-medium text-body-2 mb-1">
                          Filter Berdasarkan Role
                        </p>
                        <p class="text-body-2 text-medium-emphasis mb-0">
                          Tampilkan hanya karyawan dengan role tertentu. Contoh: lihat semua kasir.
                        </p>
                      </div>
                    </div>
                  </VCol>
                  <VCol cols="12" md="4">
                    <div class="d-flex gap-2 align-start">
                      <VIcon icon="ri-toggle-line" color="success" size="18" class="mt-1" />
                      <div>
                        <p class="font-weight-medium text-body-2 mb-1">
                          Filter Status Aktif
                        </p>
                        <p class="text-body-2 text-medium-emphasis mb-0">
                          Tampilkan hanya yang aktif, hanya yang nonaktif, atau semua karyawan.
                        </p>
                      </div>
                    </div>
                  </VCol>
                </VRow>
              </VCardText>
            </VCard>

            <!-- FAQ User -->
            <h5 class="text-h5 font-weight-bold mb-3">
              ❓ Pertanyaan Seputar Manajemen User
            </h5>
            <VExpansionPanels variant="accordion" class="mb-6">
              <VExpansionPanel v-for="(item, i) in faqUser" :key="i">
                <VExpansionPanelTitle class="text-body-2 font-weight-medium">
                  {{ item.q }}
                </VExpansionPanelTitle>
                <VExpansionPanelText>
                  <p class="text-body-2 mb-0">{{ item.a }}</p>
                </VExpansionPanelText>
              </VExpansionPanel>
            </VExpansionPanels>
          </VTabsWindowItem>

          <!-- ─── TAB 2: ROLE ──────────────────────────────────────────────── -->
          <VTabsWindowItem value="role">

            <!-- Cara akses -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-map-pin-line" class="me-2" color="primary" />
                Cara Membuka Halaman Role & Permission
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-0">
                  Di menu sidebar kiri, klik <strong>Administrasi → Role & Permission</strong>.
                  Anda akan melihat tampilan kartu-kartu, masing-masing mewakili satu role
                  yang ada di toko Anda.
                </p>
              </VCardText>
            </VCard>

            <!-- Contoh role yang disarankan -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-award-line" class="me-2" color="warning" />
                Rekomendasi Role untuk UMKM
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-4">
                  Sebelum membuat role, rencanakan dulu jabatan apa saja yang ada di toko Anda.
                  Berikut contoh role yang umum digunakan UMKM di Indonesia:
                </p>

                <VExpansionPanels variant="accordion">
                  <VExpansionPanel v-for="role in contohRole" :key="role.nama">
                    <VExpansionPanelTitle>
                      <div class="d-flex align-center gap-3">
                        <VAvatar :color="role.color" variant="tonal" size="36">
                          <VIcon :icon="role.icon" size="18" />
                        </VAvatar>
                        <span class="font-weight-medium text-body-2">{{ role.nama }}</span>
                      </div>
                    </VExpansionPanelTitle>
                    <VExpansionPanelText>
                      <VRow>
                        <VCol cols="12" md="4">
                          <p class="text-caption text-medium-emphasis mb-1 font-weight-bold">
                            COCOK UNTUK
                          </p>
                          <p class="text-body-2 mb-0">{{ role.cocok }}</p>
                        </VCol>
                        <VCol cols="12" md="5">
                          <p class="text-caption text-medium-emphasis mb-1 font-weight-bold">
                            PERMISSION YANG DIREKOMENDASIKAN
                          </p>
                          <p class="text-body-2 mb-0">
                            <code class="text-caption">{{ role.permissions }}</code>
                          </p>
                        </VCol>
                        <VCol cols="12" md="3">
                          <VAlert type="warning" variant="tonal" density="compact">
                            <p class="text-caption mb-0">{{ role.catatan }}</p>
                          </VAlert>
                        </VCol>
                      </VRow>
                    </VExpansionPanelText>
                  </VExpansionPanel>
                </VExpansionPanels>
              </VCardText>
            </VCard>

            <!-- Cara buat role -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-add-circle-line" class="me-2" color="success" />
                Cara Membuat Role Baru
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <ol class="text-body-2 ps-4">
                  <li class="mb-3">
                    Buka menu <strong>Administrasi → Role & Permission</strong>
                  </li>
                  <li class="mb-3">
                    Klik tombol <strong>"+ Tambah Role"</strong> di pojok kanan atas
                  </li>
                  <li class="mb-3">
                    Isi <strong>Nama Role</strong> — gunakan nama jabatan yang jelas dan mudah diingat.
                    <VAlert type="info" variant="tonal" density="compact" class="mt-2">
                      <strong>Tips penamaan:</strong> Gunakan huruf kecil tanpa spasi atau tanda baca khusus.
                      Contoh yang baik: <code>kasir</code>, <code>supervisor</code>, <code>kepala-gudang</code>.
                      Hindari: <code>Kasir Pagi!</code>, <code>Role #1</code>.
                    </VAlert>
                  </li>
                  <li class="mb-3">
                    Klik <strong>"Buat & Atur Permission"</strong>. Anda akan langsung diarahkan
                    ke halaman untuk mengatur permission role tersebut.
                  </li>
                </ol>
              </VCardText>
            </VCard>

            <!-- Cara atur permission -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-settings-3-line" class="me-2" color="primary" />
                Cara Mengatur Permission Sebuah Role
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-4">
                  Di halaman edit role, Anda akan melihat daftar <strong>semua fitur/menu</strong>
                  yang ada di PintuKasir, dikelompokkan berdasarkan modul. Centang fitur mana
                  yang boleh diakses oleh role ini.
                </p>

                <VRow class="mb-4">
                  <VCol cols="12" md="6">
                    <VCard variant="outlined">
                      <VCardText class="pa-4">
                        <p class="font-weight-bold text-body-2 mb-3">
                          📋 Cara Membaca Permission Matrix
                        </p>
                        <ul class="text-body-2 ps-4 mb-0">
                          <li class="mb-2">
                            Permission dikelompokkan per <strong>modul</strong>
                            (Produk, Kasir, Laporan, dst.)
                          </li>
                          <li class="mb-2">
                            Klik <strong>nama grup</strong> untuk centang/hapus semua permission
                            dalam grup tersebut sekaligus
                          </li>
                          <li class="mb-2">
                            Centang <strong>permission individual</strong> untuk pilih satu per satu
                          </li>
                          <li>
                            Panel kanan menampilkan <strong>jumlah permission terpilih</strong>
                            dari total yang tersedia
                          </li>
                        </ul>
                      </VCardText>
                    </VCard>
                  </VCol>
                  <VCol cols="12" md="6">
                    <VCard variant="outlined">
                      <VCardText class="pa-4">
                        <p class="font-weight-bold text-body-2 mb-3">
                          ⚡ Tombol Cepat
                        </p>
                        <div class="d-flex gap-2 mb-3">
                          <VChip color="primary" variant="tonal" size="small">Pilih Semua</VChip>
                          <span class="text-body-2 text-medium-emphasis">
                            — Centang semua permission sekaligus.
                            Cocok untuk role Owner/Manager.
                          </span>
                        </div>
                        <div class="d-flex gap-2">
                          <VChip color="secondary" variant="tonal" size="small">Hapus Semua</VChip>
                          <span class="text-body-2 text-medium-emphasis">
                            — Hapus semua centang. Berguna untuk mulai dari awal.
                          </span>
                        </div>
                      </VCardText>
                    </VCard>
                  </VCol>
                </VRow>

                <ol class="text-body-2 ps-4">
                  <li class="mb-2">
                    Centang permission yang diinginkan (atau klik "Pilih Semua" jika role ini
                    boleh akses semua fitur)
                  </li>
                  <li class="mb-2">
                    Lihat panel kanan — pastikan jumlah permission yang dipilih sudah sesuai
                  </li>
                  <li class="mb-2">
                    Klik <strong>"Simpan Permission"</strong>
                  </li>
                  <li>
                    Anda akan kembali ke halaman daftar role. Role baru muncul di daftar ✅
                  </li>
                </ol>

                <VAlert type="success" variant="tonal" class="mt-4">
                  <strong>💡 Perubahan langsung berlaku!</strong>
                  Setelah Anda simpan, karyawan yang memiliki role tersebut akan mendapatkan
                  atau kehilangan akses segera setelah mereka refresh halaman browser mereka.
                  Tidak perlu mereka logout/login ulang.
                </VAlert>
              </VCardText>
            </VCard>

            <!-- Edit role -->
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-edit-line" class="me-2" color="warning" />
                Cara Mengubah Permission Role yang Sudah Ada
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <ol class="text-body-2 ps-4">
                  <li class="mb-2">
                    Di halaman Role & Permission, temukan kartu role yang ingin diubah
                  </li>
                  <li class="mb-2">
                    Klik tombol <strong>"Kelola Permission"</strong> di bagian bawah kartu tersebut
                  </li>
                  <li class="mb-2">
                    Tambah atau hapus centang permission sesuai kebutuhan
                  </li>
                  <li>
                    Klik <strong>"Simpan Permission"</strong>
                  </li>
                </ol>
              </VCardText>
            </VCard>

            <!-- Tips keamanan -->
            <VCard color="error" variant="tonal" class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-shield-cross-line" class="me-2" />
                ⚠️ Tips Keamanan Akses Toko Anda
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <VList density="compact" bg-color="transparent">
                  <VListItem prepend-icon="ri-error-warning-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Jangan berikan permission "roles.update" ke kasir.</strong>
                      Karyawan yang bisa edit role bisa memberikan diri sendiri akses ke semua fitur.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-error-warning-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Batasi akses "orders.void" hanya ke supervisor atau owner.</strong>
                      Void transaksi bisa digunakan untuk menyembunyikan penjualan jika tidak diawasi.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-error-warning-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Batasi akses "reports.view" hanya ke orang yang perlu.</strong>
                      Laporan berisi data keuangan sensitif toko Anda.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-error-warning-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Rutin review role setiap 3 bulan.</strong>
                      Pastikan karyawan lama yang sudah resign sudah dinonaktifkan.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-error-warning-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Jangan share password antarkaryawan.</strong>
                      Setiap karyawan harus punya akun sendiri agar audit log akurat.
                    </VListItemTitle>
                  </VListItem>
                </VList>
              </VCardText>
            </VCard>

            <!-- FAQ Role -->
            <h5 class="text-h5 font-weight-bold mb-3">
              ❓ Pertanyaan Seputar Role & Permission
            </h5>
            <VExpansionPanels variant="accordion">
              <VExpansionPanel v-for="(item, i) in faqRole" :key="i">
                <VExpansionPanelTitle class="text-body-2 font-weight-medium">
                  {{ item.q }}
                </VExpansionPanelTitle>
                <VExpansionPanelText>
                  <p class="text-body-2 mb-0">{{ item.a }}</p>
                </VExpansionPanelText>
              </VExpansionPanel>
            </VExpansionPanels>
          </VTabsWindowItem>

          <!-- ─── TAB 3: REFERENSI PERMISSION ────────────────────────────── -->
          <VTabsWindowItem value="referensi">
            <VCard class="mb-4">
              <VCardTitle class="pa-5 pb-2">
                <VIcon icon="ri-list-check-3" class="me-2" color="primary" />
                Daftar Lengkap Permission di PintuKasir
              </VCardTitle>
              <VCardText class="pa-5 pt-3">
                <p class="text-body-2 mb-4">
                  Berikut adalah semua <strong>{{ permissionGroups.reduce((a, g) => a + g.permissions.length, 0) }} permission</strong>
                  yang tersedia di sistem PintuKasir, beserta penjelasan fungsinya.
                  Gunakan tabel ini sebagai referensi saat mengatur role.
                </p>

                <div v-for="group in permissionGroups" :key="group.group" class="mb-6">
                  <div class="d-flex align-center gap-2 mb-3">
                    <VAvatar :color="group.color" variant="tonal" size="32">
                      <VIcon :icon="group.icon" size="16" />
                    </VAvatar>
                    <h6 class="text-h6 font-weight-bold mb-0">{{ group.group }}</h6>
                  </div>

                  <VTable density="compact">
                    <thead>
                      <tr>
                        <th style="min-width:200px">Kode Permission</th>
                        <th style="min-width:160px">Nama Akses</th>
                        <th>Artinya: karyawan bisa...</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="perm in group.permissions" :key="perm.name">
                        <td>
                          <code class="text-caption">{{ perm.name }}</code>
                        </td>
                        <td>
                          <VChip :color="group.color" variant="tonal" size="small" label>
                            {{ perm.label }}
                          </VChip>
                        </td>
                        <td class="text-body-2 text-medium-emphasis py-2">
                          {{ perm.desc }}
                        </td>
                      </tr>
                    </tbody>
                  </VTable>
                </div>
              </VCardText>
            </VCard>
          </VTabsWindowItem>

        </VTabsWindow>
      </VCol>
    </VRow>

    <!-- ═══════════════════════════════════════════════════════════════════════
         SECTION BAWAH: Tips + Langkah Selanjutnya
    ════════════════════════════════════════════════════════════════════════════ -->

    <!-- Tips praktis -->
    <VRow class="mt-2">
      <VCol cols="12">
        <VCard color="warning" variant="tonal">
          <VCardTitle class="pa-5 pb-2">
            <VIcon icon="ri-lightbulb-line" class="me-2" />
            💡 Tips Praktis untuk Pemilik UMKM
          </VCardTitle>
          <VCardText class="pa-5 pt-3">
            <VRow>
              <VCol cols="12" md="6">
                <VList density="compact" bg-color="transparent">
                  <VListItem prepend-icon="ri-star-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Setup role sebelum tambah karyawan.</strong>
                      Lebih mudah jika role sudah tersedia saat Anda membuat akun karyawan baru.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-star-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Mulai dari 3 role saja: Owner, Supervisor, Kasir.</strong>
                      Tambah role baru seiring toko berkembang. Jangan terlalu banyak dari awal.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-star-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Gunakan nama karyawan asli saat buat akun.</strong>
                      Nama yang jelas memudahkan identifikasi di laporan dan audit log.
                    </VListItemTitle>
                  </VListItem>
                </VList>
              </VCol>
              <VCol cols="12" md="6">
                <VList density="compact" bg-color="transparent">
                  <VListItem prepend-icon="ri-star-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Nonaktifkan, jangan hapus, akun karyawan lama.</strong>
                      Data riwayat transaksinya masih berguna untuk laporan dan audit.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-star-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Buat password yang berbeda untuk setiap karyawan.</strong>
                      Jangan pakai password yang sama untuk semua karyawan.
                    </VListItemTitle>
                  </VListItem>
                  <VListItem prepend-icon="ri-star-line">
                    <VListItemTitle class="text-body-2 text-wrap">
                      <strong>Cek Audit Log setiap minggu.</strong>
                      Lihat aktivitas mencurigakan seperti void transaksi di luar jam kerja.
                    </VListItemTitle>
                  </VListItem>
                </VList>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- Langkah selanjutnya -->
    <VRow class="mt-4 mb-2">
      <VCol cols="12">
        <h5 class="text-h5 font-weight-bold mb-3">
          🔗 Halaman Terkait
        </h5>
        <VRow>
          <VCol
            v-for="link in [
              {
                title: 'Audit Log',
                sub: 'Lihat siapa melakukan apa dan kapan di sistem',
                icon: 'ri-file-search-line',
                color: 'secondary',
                to: '/userguide/sistem/audit-log',
              },
              {
                title: 'Pengaturan Toko',
                sub: 'Konfigurasi nama toko, pajak, dan struk',
                icon: 'ri-equalizer-line',
                color: 'primary',
                to: '/userguide/sistem/pengaturan',
              },
              {
                title: 'Dashboard Laporan',
                sub: 'Pantau penjualan harian dan KPI bisnis',
                icon: 'ri-dashboard-line',
                color: 'success',
                to: '/userguide/laporan/dashboard',
              },
            ]"
            :key="link.title"
            cols="12"
            md="4"
          >
            <RouterLink :to="link.to" class="text-decoration-none">
              <VCard variant="outlined" hover>
                <VCardText class="d-flex align-center gap-3 py-3">
                  <VAvatar :color="link.color" variant="tonal" size="40" rounded>
                    <VIcon :icon="link.icon" size="22" />
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-0">{{ link.title }}</p>
                    <p class="text-caption text-medium-emphasis mb-0">{{ link.sub }}</p>
                  </div>
                </VCardText>
              </VCard>
            </RouterLink>
          </VCol>
        </VRow>
      </VCol>
    </VRow>
  </div>
</template>
